import { useState } from 'react'
import { ColorResult, SketchPicker } from 'react-color'

type Props = {
    color: string
    onColorChanged: (hex: string) => void
}

export const ClassColorPicker = (props: Props): JSX.Element | null => {

    const [show, setShow] = useState(false)

    const handleClick = () => setShow(!show)
    const handleClose = () => setShow(false)
    const handleChange = (color: ColorResult) => {
        props.onColorChanged(color.hex)
    }

    return (
        <div className="d-flex">
            <div
                style={{
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '3px',
                    boxShadow: '0 0 0 1px #ced4da',
                    // display: 'inline-block',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            >

                <div
                    className="flex-grow-1"
                    style={{
                        width: '27px',
                        height: '27px',
                        borderRadius: '2px',
                        background: props.color
                    }}
                />

            </div>
            { show ? <div style={{
                position: 'absolute',
                zIndex: 2
            }}>
                <div style={{
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                }} onClick={handleClose} />
                <SketchPicker
                    color={props.color}
                    disableAlpha={true}
                    presetColors={[
                        '#C41E3A',
                        '#A330C9',
                        '#FF7C0A',
                        '#AAD372',
                        '#3FC7EB',
                        '#00FF98',
                        '#F48CBA',
                        '#C69B6D',
                        '#0070DD',
                        '#8788EE',
                        '#000',
                        '#3d3d3d',
                        '#6d6d6d',
                        '#9d9d9d',
                    ]}
                    onChange={handleChange}
                />
            </div> : null}
        </div>
    )
}
